export default "314bbd98299a937a.png"